import React from 'react';
import { LandingPage } from './components/LandingPage';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <>
      <MetaPixel data-id="element-0" />
      <LandingPage data-id="element-1" />
    </>;
}